import { ACTION } from './action-types';
import { ApplicationState } from 'app/types-store';
import { Reducer } from 'redux';

/**
 * Special reducers that can handle changes on any part of our state object, as opposed to
 * default redux with combineReducers that operate on their individual slice of the store
 */
export const textCollectionReducer: Reducer<ApplicationState> = (state: ApplicationState, action: any) => {

  if (ACTION.ReceiveTextCollection === action.type) {

    return !!state[action.path] && state[action.path].textsLanguage === action.language ? {
      ...state,
      [action.path]: {
        ...state[action.path],
        texts: action.texts,
        textsFetching: false
      }
    } : state;

  }

  if (ACTION.RequestTextCollection === action.type) {

    return {
      ...state,
      [action.path]: {
        ...state[action.path],
        textsLanguage: action.language,
        textsFetching: true
      }
    };
  }

  return state;
};
